document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('logoSliderWrapper');
  const slides = wrapper?.children;
  if (!wrapper || !slides || slides.length === 0) return;

  function isMobile() {
    return window.innerWidth < 768;
  }

  if (!isMobile()) return; // only run slider on mobile

  let index = 0;

  setInterval(() => {
    index++;
    if (index > slides.length - 3) {
      index = 0;
    }
    const slideWidth = slides[0].offsetWidth + 20; // slide + gap
    wrapper.style.transform = `translateX(-${index * slideWidth}px)`;
  }, 2000);
});

// document.addEventListener('DOMContentLoaded', function () {
//   const wrapper = document.getElementById('logoSliderWrapper');
//   const slides = wrapper?.children;
//   if (!wrapper || !slides || slides.length === 0) return;

//   const totalSlides = slides.length;

//   function isMobile() {
//     return window.innerWidth < 1300;
//   }

//   let visibleCount = isMobile() ? 3 : 6;

//   // Only run slider if total slides > visible count
//   if (totalSlides <= visibleCount) return;

//   let index = 0;

//   setInterval(() => {
//     index++;
//     if (index > totalSlides - visibleCount) {
//       index = 0;
//     }

//     const slideWidth = slides[0].offsetWidth + 20; // slide width + gap
//     wrapper.style.transform = `translateX(-${index * slideWidth}px)`;
//   }, 2000);
// });

// // window.addEventListener('resize', () => {
// //   location.reload();
// // });